/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { publicBookingConfirm } from '../../axios/publicBookingConfirm'
import type {
	PublicBookingConfirmError,
	PublicBookingConfirmPathParams,
	PublicBookingConfirmRequest,
	PublicBookingConfirmResponse,
} from '../../types/PublicBookingConfirm'

export const publicBookingConfirmMutationKey = () =>
	[{ url: '/interview-scheduling/booking/:tokenString/confirm' }] as const

export type PublicBookingConfirmMutationKey = ReturnType<typeof publicBookingConfirmMutationKey>

export type PublicBookingConfirmVariables = {
	tokenString: PublicBookingConfirmPathParams['tokenString']
	data: PublicBookingConfirmRequest
}

/** @see backend/nexus/modules/InterviewScheduling/Http/Controllers/PublicBookingController.php PublicBookingController::confirm */
export function usePublicBookingConfirm<TContext = unknown>(
	options?: UseMutationOptions<
		PublicBookingConfirmResponse,
		AxiosError<PublicBookingConfirmError>,
		PublicBookingConfirmVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: publicBookingConfirmMutationKey(),
		mutationFn: ({ tokenString, data }: PublicBookingConfirmVariables) =>
			publicBookingConfirm(tokenString, data, config).then(res => res.data),
		...options,
	})
}
